// eslint-disable-next-line import/prefer-default-export
export const getNoDataMessage = (hasVendors, hasProductsWithVendors) => {
  if (!hasVendors) {
    return 'Please have a brand manager set up vendors to assign to your products.';
  }

  if (!hasProductsWithVendors) {
    return 'Please assign vendors to your products in order to add them to a PO.';
  }

  return `No products have this vendor assigned.
    Please expand your filter to find products with vendor assignments to add to a PO.`;
};
